import { http } from '../../../../api/axios';
import { productConfig } from '../../../../config';
import { Article } from '../../../../../models/Article';
import { ProductMetaData } from '../../../../../models/Product';

export const fetchProduct = (productId: string) => {
    return http
        .get<ProductMetaData & Article>(productConfig().endpointProduct, {
            pathParams: { productId },
            errorCodesToSkip: [404]
        })
        .then(response => response.data);
};
